<template>
  <div class="card-body">
    <h1 class="text-muted text-center">
      {{$t('message.spots.message.spot')}}
    </h1>

    <div class="creation-body">
      <app-stepper-section half-width style="margin-right: 15px;" class="coluna-esquerda">
        <app-stepper-section :label="$t('message.generics.message.generalData')">
          <v-text-field ref="firstInput" :label="$t('message.spots.message.spotName')" name="Nome do Local" v-validate="'required'"
            :autofocus="true" :error-messages="errors.collect($t('message.spots.message.spotName'))" :value="value.name"
            @input="update('name', $event)"></v-text-field>
        </app-stepper-section>

        <app-stepper-section :label="$t('message.spots.message.connectionTimeout')" inline class="alinhar-items">
          <app-select class="creation-body-timeout" :value="value.timeoutType" :data-title="$t('message.spots.message.select')"
            :data-search="false" :data-items="timeoutTypes"  data-menu-width="fit-content" :clearable="false" @input="update('timeoutType', $event)" />
          <v-text-field :label="$t('message.spots.message.timeout')" name="Tempo" :value="value.timeout" v-validate="'required'" mask="#####"
            return-masked-value :error-messages="errors.collect($t('message.spots.message.timeout'))" @input="update('timeout', $event)">
          </v-text-field>
        </app-stepper-section>

        <app-stepper-section :label="$t('message.spots.message.timeNextAccess')" inline class="alinhar-items">
          <app-select id="nextAccessSelect" class="creation-body-timeout" :value="value.blockTimeoutUnit" :data-title="$t('message.spots.message.select')"
            :data-search="false" :data-items="timeoutTypes" data-menu-width="fit-content" :clearable="false" @input="update('blockTimeoutUnit', $event)" />
          <v-text-field :label="$t('message.spots.message.timeout')" name="Tempo" :value="value.blockTimeout" mask="#####"
            return-masked-value  @input="update('blockTimeout', $event)">
          </v-text-field>
        </app-stepper-section>

        <app-stepper-section :label="$t('message.spots.message.timezone')" class="alinhar-items">
          <app-select :value="value.timezone" :data-title="$t('message.spots.message.select')" :data-search="false" :data-items="timezoneOptions"
            :clearable="false" data-menu-height="300px" data-menu-width="350px" @input="update('timezone', $event)" />
        </app-stepper-section>

        <app-stepper-section :label="$t('message.spots.message.controller')" class="alinhar-items">
          <app-select :value="value.apControllerId" :data-title="$t('message.spots.message.select')" :data-search="false"
            :data-items="accessPointsControllers" :clearable="false" @input="update('apControllerId', $event)" />
        </app-stepper-section>

        <app-stepper-section :label="$t('message.spots.message.category')" class="alinhar-items">
          <app-select :value="value.category" :data-title="$t('message.spots.message.select')" :data-search="true"
            :data-items="categoryOptions" :no-results="categoryOptions.length === 0"  data-menu-width="350px" :clearable="false" @input="update('category', $event)" 
            @search="setCategorySearch" @hidden="categorySearch = undefined"/>
        </app-stepper-section>

        <app-stepper-section :label="$t('message.spots.message.over18YearsOld')" class="alinhar-items">
          <app-select :value="value.checkAge" :data-title="$t('message.spots.message.select')" :data-search="false" :data-items="booleanTypes"
            :clearable="false" @input="update('checkAge', $event)" />
        </app-stepper-section>

        <app-stepper-section label="Requerer Message-Authenticator" :help="messageAuthenticatorHelpText" class="alinhar-items" @on-help-click="openDocsPage">
          <app-select :value="value.requireMessageAuthenticator" :data-title="$t('message.spots.message.select')" :data-search="false" :data-items="booleanTypes"
            :clearable="false" @input="update('requireMessageAuthenticator', $event)" />
        </app-stepper-section>

      </app-stepper-section>

      <app-stepper-section :label="$t('message.admGenerics.message.address')" half-width class="coluna-direita">
        <v-text-field name="Cep" :error-messages="errors.collect($t('message.admGenerics.message.zipCode'))" :label="$t('message.admGenerics.message.zipCode')" v-on:blur="findAddress()"
          v-model="zipcode" mask="#####-###"></v-text-field>

        <v-text-field name="Rua" :error-messages="errors.collect($t('message.admGenerics.message.street'))" :label="$t('message.admGenerics.message.street')" v-model="streetName">
        </v-text-field>

        <v-text-field name="Número" :error-messages="errors.collect($t('message.admGenerics.message.streetNumber'))" :label="$t('message.admGenerics.message.streetNumber')" v-model="streetNumber">
        </v-text-field>

        <v-text-field name="Complemento" :error-messages="errors.collect($t('message.admGenerics.message.streetExtra'))" :label="$t('message.admGenerics.message.streetExtra')"
          v-model="extra"></v-text-field>

        <v-text-field name="Bairro" :error-messages="errors.collect($t('message.admGenerics.message.neighborhood'))" :label="$t('message.admGenerics.message.neighborhood')" v-model="neighborhood"
          v-validate="'required'"></v-text-field>

        <v-text-field name="Cidade" :error-messages="errors.collect($t('message.admGenerics.message.city'))" :label="$t('message.admGenerics.message.city')" v-model="city"
          v-validate="'required'"></v-text-field>

        <v-text-field name="UF" :error-messages="errors.collect($t('message.admGenerics.message.state'))" :label="$t('message.admGenerics.message.state')" v-model="state"
          v-validate="'required'"></v-text-field>
      </app-stepper-section>

    </div>

    <app-stepper-section :label="$t('message.spots.message.observations')">
      <v-textarea v-model="notes" label outlined :rows="4" no-resize></v-textarea>
    </app-stepper-section>

  </div>
</template>

<script>
import AppStepperSection from "@components/StepperSection";
import AppSelect from "@components/Select";

export default {
  components: {
    AppStepperSection,
    AppSelect,
  },

  props: {
    value: {
      type: Object,
    },
    show: {
      type: Boolean,
    },
  },

  watch: {
    show(val) {
      if (val) {
        this.$validator.reset();
        this.$refs.firstInput.focus();
      }
    },
  },

  data() {
    return {
      timeoutTypes: [
        { id: "MINUTO", label: this.$t('message.spots.message.minute') },
        { id: "HORA", label: this.$t('message.spots.message.hour') },
      ],
      booleanTypes: [
        { id: true, label: this.$t('message.spots.message.yes') },
        { id: false, label: this.$t('message.spots.message.no') },
      ],
      categorySearch: undefined,
      messageAuthenticatorHelpText: "<div> Essa configuração altera o RADIUS utilizado durante a liberação do cliente para um com a correção de segurança que requer o envio do Message-Authenticator. Para que essa configuração funcione corretamente, você deve alterar também a configuração de RADIUS do seu equipamento com as novas portas e senha do WiFeed. <strong>Clique no ícone para acessar a documentação e entender melhor.</strong></div>"
    };
  },

  methods: {
    openDocsPage() {
      const linkToDocsPage = document.createElement('a')
      linkToDocsPage.href = 'https://wifeed.atlassian.net/wiki/external/NzNiNGQwZGVkOGIyNDlhNGE3ZGYyYzI5OGUyM2RjMDc'
      linkToDocsPage.target = '_blank'
      linkToDocsPage.click()
    },
    async validate() {
      await this.$validator.validateAll();

      if (this.$validator.errors.items.length !== 0)
        return

      this.$emit("valid");
    },

    update(key, value) {
      this.$emit("input", { ...this.value, [key]: value });
    },

    async findAddress() {
      if (!this.zipcode || this.zipcode.replace("-", "").length < 8) return;

      const address = await this.$api.address.search(
        this.zipcode.replace("-", "")
      );

      this.$emit("input", { ...this.value, ...address });
    },
    
    setCategorySearch(value) {
      this.categorySearch = value
    }
  },

  computed: {
    zipcode: {
      get() {
        return this.value.zipcode;
      },
      set(zipcode) {
        this.$emit("input", { ...this.value, zipcode });
      },
    },
    streetName: {
      get() {
        return this.value.streetName;
      },
      set(streetName) {
        this.$emit("input", { ...this.value, streetName });
      },
    },
    streetNumber: {
      get() {
        return this.value.streetNumber;
      },
      set(streetNumber) {
        this.$emit("input", { ...this.value, streetNumber });
      },
    },
    extra: {
      get() {
        return this.value.extra;
      },
      set(extra) {
        this.$emit("input", { ...this.value, extra });
      },
    },
    neighborhood: {
      get() {
        return this.value.neighborhood;
      },
      set(neighborhood) {
        this.$emit("input", { ...this.value, neighborhood });
      },
    },
    city: {
      get() {
        return this.value.city;
      },
      set(city) {
        this.$emit("input", { ...this.value, city });
      },
    },
    state: {
      get() {
        return this.value.state;
      },
      set(state) {
        this.$emit("input", { ...this.value, state });
      },
    },
    notes: {
      get() {
        return this.value.notes;
      },
      set(notes) {
        this.$emit("input", { ...this.value, notes });
      },
    },
    timezoneOptions() {
      return this.$store.state.local.timeZones
    },
    categoryList() {
      return this.$store.state.local.categories
    },
    categoryOptions() {
      if(this.categorySearch) {
        return this.categoryList.filter(category => category.label.toLowerCase().includes(this.categorySearch.toLowerCase()))
      }
      return this.$store.state.local.categories
    },
    
    accessPointsControllers() {
      const list = this.$store.state.local.controllers.list;

      if(!list) return       

      let accessPointControllers = [
        {
          id: null,
          label: this.$t('message.spots.message.standard'),
        },
      ];

      accessPointControllers.push(
        ...list.map((accessPointController) => {
          return {
            id: accessPointController.id,
            label: accessPointController.name,
          };
        })
      );

      return accessPointControllers
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";
.coluna-direita{
  .v-input{
    margin-bottom: 5px!important;
  }
}
.coluna-esquerda{
  .v-input{
    margin-bottom: -50px!important;
  }
}

.alinhar-items {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-bottom: -20px!important;
}

.card-body {
  padding: 18px 50px 10px;

  .v-input {
    margin: 12px 0 10px 0;
  }

  .creation-body {
    display: flex;
    gap: 50px;

    .stepper-section {
      margin-bottom: 20px;
    }

    .dropdown {
      margin: 0 auto 10px;

      &.creation-body-timeout {
        margin-right: 15px;

      }
    }

  }
}
</style>

